<template>
  <div class="container-fluid container-wrap col-sm-12 col-xs-12">
    <div class="row justify-content-center">
      <div class="col-sm-12 col-xs-12">
        <div
            class="card-header pb-0 col-sm-12 d-flex mainDiv certiDiv hospital-div-wrap"
        >
          <div class="col-sm-12 col-xs-12">
            <div class="col-sm-12 col-xs-12 titleDiv hospital-div-wrapTitle">
              <div class="col-sm-10">
                <h3>{{ $t('hospital_header_title') }}</h3>
                <h5>{{ $t('hospital_header_desc1') }}<br/>{{ $t('hospital_header_desc2') }}</h5>
              </div>
            </div>

            <div class="card-body px-0 pt-0 pb-2">
              <div class="card content-wrap-card col-sm-12 col-xs-12 cm">
                <h4>{{ $t('hospitalw_info') }}</h4>
                <div class="col-sm-12 inputDiv">
                  <label class="label-title" >{{ $t('hospitalw_cno') }}<span class="required-span"/></label>
                  <div class="d-flex justify-content-between" style="flex: 1;">
                    <div class="position-relative col-sm-6 w-100">
                      <a-input
                          class="w-100 input-text-common"
                          type="text"
                          v-model:value="businessNumber"
                          :maxlength="12"
                          @change="changeBusinessNumber"
                          @keyup.enter="validateBusinessNumber"
                          :placeholder="$t('hospitalw_cno_placeholder')"
                      />
                      <a-button
                          class="position-absolute black no-radius-left"
                          @click="validateBusinessNumber"
                          style="top: 0; right: 0"
                      >
                        {{ $t('hospitalw_hospitalcode_validate') }}
                      </a-button>
                      <span class="businessNumberMsg fail" />
                    </div>
                  </div>
                </div>
                <div class="col-sm-12 inputDiv">
                  <label class="label-title" >{{ $t('hospitalw_name') }}<span class="required-span"/></label>
                  <div class="" style="flex: 1;">
                    <a-input
                        class="w-100 input-text-common"
                        v-model:value="hospitalName"
                        :placeholder="$t('hospitalw_name_placeholder')"
                    />
                  </div>
                </div>
                <div class="col-sm-12 inputDiv">
                  <label class="label-title" >{{ $t('hospitalw_ceo') }}</label>
                  <div class="" style="flex: 1;">
                    <a-input
                        class="w-100 input-text-common"
                        v-model:value="hospitalCeoName"
                        :placeholder="$t('hospitalw_ceo_placeholder')"
                    />
                  </div>
                </div>
                <div class="col-sm-12 inputDiv">
                  <label class="label-title" >{{ $t('hospitalw_medicaldept') }}<span class="required-span"/></label>
                  <div style="display: flex; flex-wrap: wrap; flex: 1;">
                    <a-checkbox-group v-model:value="medicalDept" style="width: 100%">
                      <a-checkbox
                          v-for="(item, i) in deptList"
                          :key="i"
                          :value="item.code"
                      >
                        {{ item.name }}
                      </a-checkbox>
                    </a-checkbox-group>
                  </div>
                </div>
                <div class="col-sm-12 inputDiv">
                  <label class="label-title" >{{ $t('hospitalw_address') }}<span class="required-span"/></label>
                  <div class="d-flex flex-column" style="flex: 1;">
                    <div
                        class="d-flex col-sm-12 justify-content-between location-wrap"
                    >
                      <a-select
                          class="hospital"
                          v-model:value="selectedAreaFirst"
                          @change="areaSecondChange"
                          :placeholder="$t('hospital_search_level1')"
                      >
                        <a-select-option value="" selected>{{ $t('hospital_search_level1') }}</a-select-option>
                        <a-select-option
                            v-for="item in areaFirst"
                            :value="item"
                            :key="item"
                        >
                          {{ `${item}` }}
                        </a-select-option>
                      </a-select>
                      <a-select
                          class="hospital"
                          v-model:value="selectedAreaSecond"
                          @change="areaThirdChange"
                          :placeholder="$t('hospital_search_level2')"
                      >
                        <a-select-option value="" selected>{{ $t('hospital_search_level2') }}</a-select-option>
                        <a-select-option
                            v-for="item in areaSecond"
                            :value="item"
                            :key="item"
                        >
                          {{ `${item}` }}
                        </a-select-option>
                      </a-select>
                      <a-select
                          class="hospital"
                          v-model:value="selectedAreaThird"
                          :placeholder="$t('hospital_search_level1')"
                      >
                        <a-select-option value="" selected>{{ $t('hospital_search_level3') }}</a-select-option>
                        <a-select-option
                            v-for="item in areaThird"
                            :value="item"
                            :key="item"
                        >
                          {{ `${item}` }}
                        </a-select-option>
                      </a-select>
                    </div>
                    <div>
                      <a-input
                          class="input-text-common"
                          style="width: 100% !important"
                          v-model:value="addrDetail"
                          :placeholder="$t('hospitalw_detailaddress_placeholder')"
                      />
                    </div>
                  </div>
                </div>
                <div class="col-sm-12 inputDiv">
                  <label class="label-title" >{{ $t('hospitalw_phone') }}</label>
                  <div class="" style="flex: 1;">
                    <a-input
                        class="w-100 input-text-common"
                        v-model:value="hospitalPhoneNumber"
                        :maxlength="13"
                        @change="changeHospitalPhoneNumber"
                        :placeholder="$t('hospitalw_phone_placeholder')"
                    />
                  </div>
                </div>

                <div class="col-sm-12 inputDiv">
                  <label class="label-title" >{{ $t('hospitalw_cno_file') }}</label>
                  <div class="d-flex justify-content-between" style="flex: 1;">
                    <div class="position-relative col-sm-6 w-100">
                      <a-input
                          class="w-100 input-text-common"
                          v-model:value="businessFileName"
                          readonly
                      />
                      <div class="download-delete-area d-flex">
                        <div
                            class="small-btn"
                            v-if="businessImgUrl || businessFileData"
                            @click="downloadBusinessNumImage"
                        >
                          <i class="fa-solid fa-down-to-bracket"/>
                        </div>
                        <div
                            class="small-btn"
                            v-if="businessImgUrl || businessFileData"
                            @click="deleteBusinessNumFile"
                        >
                          <i class="fa-solid fa-trash-can"/>
                        </div>
                      </div>
                      <a-button
                          class="position-absolute no-radius-left black"
                          style="top: 0; right: 0"
                          @click="clickBusinessFileInput"
                      >
                        {{ $t('hospitalw_cno_btn') }}
                      </a-button>
                      <a-input
                          type="file"
                          id="businessFileInputM"
                          accept=".jpg, .jpeg, .png, .pdf"
                          ref="businessFileInputM"
                          @change="changeBusinessNumImage"
                          style="
                          position: absolute;
                          width: 1px;
                          height: 1px;
                          top: 0;
                          right: 0;
                          opacity: 0;
                        "
                          value=""
                      />
                      <span
                          style="
                          color: #8d939a;
                          font-size: 14px;
                        "
                      >• {{ $t('hospitalw_pagelogo_desc') }}</span
                      >
                    </div>
                  </div>
                </div>
                <div class="col-sm-12 inputDiv">
                  <label class="label-title" >{{ $t('hospitalw_hospitalcode') }}</label>
                  <div class="" style="flex: 1;">
                    <div class="position-relative col-sm-12">
                      <a-input
                          class="input-text-common"
                          style="width: 100% !important"
                          v-model:value="hospitalCode"
                          :placeholder="$t('hospitalw_hospitalcode_placeholder')"
                      />
                    </div>
                  </div>
                </div>
                <div class="col-sm-12 inputDiv">
                  <label class="label-title" >{{ $t('hospitalw_doctor') }}</label>
                  <div class="d-flex flex-wrap" style="flex: 1;">
                    <div class="d-flex col-sm-8 doctor-list-input ant-like-input">
                      <a-button
                          v-for="(item, index) in doctors"
                          :key="index"
                          style="height: fit-content;"
                      >
                        {{ item }}
                        <i
                            class="fa-solid fa-xmark"
                            @click="removeDoctor(index)"
                        />
                      </a-button>
                    </div>
                    <div class="col-sm-4 position-relative doctor-input-wrap">
                      <a-input
                          class="extra"
                          v-model:value="inputText"
                          @keyup.enter="addDoctor"
                          :placeholder="$t('hospitalw_doctor_placeholder')"
                          style="width: 100%;"
                      />
                      <a-button
                          class="position-absolute black no-radius-left"
                          style="top: 0; right: 0; width: 80px !important;"
                          @click="addDoctor"
                      >
                        {{ $t('hospitalw_doctor_add') }}
                      </a-button>
                    </div>
                  </div>
                </div>
                <div class="col-sm-12 inputDiv align-items-start fileDiv">
                  <label class="label-title" >{{ $t('hospitalw_pagelogo') }}</label>
                  <div class="file-box">
                    <img
                        :src="logoImgUrl"
                        :alt="$t('hospitalw_logo_alt')"
                        ref="logoPrevM"
                        id="logoPrevM"
                        :style="logoImgUrl || logoFileData ? 'display: block;' : 'display: none;'"
                        @click="downloadLogoImage"
                    />
                    <i class="fa-solid fa-image"
                       :style="logoImgUrl || logoFileData ? 'display: none;' : 'display: block;'"
                    />
                    <span
                        :style="logoImgUrl || logoFileData ? 'display: none;' : 'display: block;'"
                    >{{ $t('companyinfo_companylogo_placeholder1') }}<br />{{ $t('companyinfo_companylogo_placeholder2') }}</span>
                    <input
                        type="file"
                        accept="image/jpeg, image/png, image/gif"
                        @change="changeLogoImage"
                        id="logoFileInputM"
                        ref="logoFileInputM"
                    />
                  </div>
                  <div class="button-box d-flex flex-column">
                    <div class="d-flex">
                      <a-button
                          class="black"
                          style="margin-right: 10px;"
                          @click="clickLogoFileInput"
                      >
                        {{ $t('companyinfo_image_btn_upload') }}
                      </a-button>
                      <a-button
                          @click="deleteLogoImage"
                      >
                        {{ $t('companyinfo_image_btn_delete') }}
                      </a-button>
                    </div>
                    <div>
                      <ul>
                        <li>{{ $t('companyinfo_image_size') }}</li>
                        <li>{{ $t('companyinfo_image_extension') }}</li>
                        <li>{{ $t('companyinfo_image_filesize') }}</li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="card-body px-0 pt-0 pb-2">
              <div class="card content-wrap-card col-sm-12 col-xs-12 cm">
                <h4>{{ $t('hospitalw_add_manager') }}</h4>
                <div class="col-sm-12 inputDiv">
                  <label class="label-title" >{{ $t('hospitalw_manager_name') }}</label>
                  <div class="d-flex justify-content-between" style="flex: 1;">
                    <div class="position-relative col-sm-6 w-100">
                      <a-input
                          v-model:value="managerName"
                          class="w-100 input-text-common"
                          :placeholder="$t('hospitalw_manager_name_placeholder')"
                      />
                    </div>
                  </div>
                </div>
                <div class="col-sm-12 inputDiv">
                  <label class="label-title" >{{ $t('hospitalw_manager_duty') }}</label>
                  <div class="d-flex div905 justify-content-between" style="flex: 1;">
                    <div class="position-relative col-sm-6 w-100">
                      <a-input
                      style="flex: 1;"
                          v-model:value="managerDuty"
                          class="w-100 input-text-common"
                          :placeholder="$t('hospitalw_manager_duty_placeholder')"
                      />
                    </div>
                  </div>
                </div>
                <div class="col-sm-12 inputDiv">
                  <label class="label-title" >{{ $t('hospitalw_manager_phone') }}</label>
                  <div class="d-flex div905 justify-content-between" style="flex: 1;">
                    <div class="position-relative col-sm-6 w-100">
                      <a-input
                      style="flex: 1;"
                          class="w-100 input-text-common"
                          v-model:value="managerPhoneNumber"
                          @change="changeManagerPhoneNumber"
                          :maxlength="13"
                          :placeholder="$t('hospitalw_manager_phone_placeholder')"
                      />
                    </div>
                  </div>
                </div>
                <div class="col-sm-12 inputDiv ">
                  <label class="label-title" >{{ $t('hospitalw_manager_id') }}</label>
                  <div class="position-relative w-35">
                    <a-input
                        v-model:value="managerId"
                        class="w-100 input-text-common"
                        :maxlength="30"
                        :placeholder="$t('hospitalw_manager_id_placeholder')"
                        @keyup.enter="validateManagerId"
                        @change="changeManagerId"
                    />
                    <a-button
                        class="position-absolute no-radius-left black"
                        @click="validateManagerId"
                        style="top: 0; right: 0; width: 143px;"
                        type="button"
                    >
                      {{ $t('hospitalw_hospitalcode_validate') }}
                    </a-button>
                    <span class="managerIdMsg fail"></span>
                  </div>
                </div>
                <div class="col-sm-12 inputDiv password-area password-input-area">
                  <label class="label-title" >{{ $t('hospitalw_manager_pw') }}</label>
                  <a-input-password
                      class="input-text-common w-35"
                      :type="isPasswordVisible ? 'text' : 'password'"
                      
                      v-model:value="password"
                      @change="passwordOnChange"
                      :placeholder="$t('hospitalw_manager_pw_placeholder')"
                  />
                </div>
                <div class="col-sm-12 inputDiv password-area password-input-area">
                  <label class="label-title" >{{ $t('hospitalw_manager_pwconfirm') }}</label>
                  <a-input-password
                      class="input-text-common w-35"
                      v-model:value="passwordConfirm"
                      @change="passwordOnChange"
                      :placeholder="$t('hospitalw_manager_pwconfirm_placeholder')"
                  />
                </div>
              </div>
            </div>
            <div class="card-body px-0 pt-0 pb-2" v-if="visibleZeissApprovalItem">
              <div class="card content-wrap-card col-sm-12 col-xs-12 cm">
                <h4 >{{ $t('hospitalw_authorization_manage') }}</h4>
                <div
                    class="col-sm-12 inputDiv"
                    v-for="(item, index) in approvedItems"
                    :key="index"
                >
                  <label class="label-title" style="width: 200px;">{{ item.editedName }}</label>
                  <div class="d-flex align-items-center">
                    <a-switch
                        v-model:checked="item.isSelected"
                    />
                    <p
                        class="true-color"
                        :id="`item-switch-text${index}`"
                    >
                      {{ item.isSelected
                        ? $i18n.t('hospitalw_message_authorized')
                        : $i18n.t('hospitalw_message_not_authorized')
                      }}
                    </p>
                  </div>
                </div>
              </div>
            </div>

            
            <div v-if="visiblePlasmappApprovalItem" class="card-body px-0 pt-0 pb-2">
              <div class="card content-wrap-card col-sm-12 col-xs-12 cm">
                <h4>{{ $t('hospitalw_add_product') }}</h4>
                <div class="col-sm-12 inputDiv mb-0">
                  <label class="label-title" >{{ $t('hospitalw_select_info') }}<span class="required-span"/></label>
                  <div class="d-flex justify-content-between hospital-product-wrap" style="flex: 1;">
                    <div class="position-relative col-sm-6 w-100 hospital-product-row">
                      <div class="input-wrap">
                        <a-select style="width: 100%;" 
                          v-model:value="selectedApproveItem"
                        >
                          <a-select-option 
                            v-for="item in approvedItems"
                            :key="item._id"
                            :value="item._id"
                          >
                            {{ item.itemName }}
                          </a-select-option>
                        </a-select>
                      </div>
                    </div>
                  </div>
                </div>
                
                <div class="col-sm-12 inputDiv mb-0" v-for="(item, index) in productArray">
                  <label class="label-title" >{{ $t('hospitalw_write_info') }}</label>
                  <div class="d-flex justify-content-between hospital-product-wrap" style="flex: 1;">
                    <div class="position-relative col-sm-6 w-100 hospital-product-row">
                      <div class="input-wrap">
                        <a-input
                            v-model:value="productArray[index].value"
                            class="w-100 input-text-common"
                            :class="
                            item.status === productCodeStatus.ok
                            ? 'approved' :
                            item.status === productCodeStatus.notFound ||
                            item.status === productCodeStatus.exist
                            ? 'not-approved'
                            : ''
                          "
                            :placeholder="$t('productslist_placeholder')"
                            @focusout="validateProductCode(index)"
                        />
                        <img v-if="item.status === productCodeStatus.ok" src="../../assets/img/approved.svg" />
                        <img
                            v-if="
                            item.status === productCodeStatus.notFound ||
                            item.status === productCodeStatus.exist
                          "
                            src="../../assets/img/not-approved.svg"
                        />
                      </div>
                      <a-button
                          @click="removeProduct(index)"
                          shape="circle"
                      >
                        <template #icon>
                          <i class="fa-duotone fa-minus"/>
                        </template>
                      </a-button>
                    </div>
                    <div
                        class="product-message success"
                        v-if="item.status === productCodeStatus.ok"
                    >
                      {{ `${$t(`hospitalw_message_product_${item.status}`)} (${item.name})` }}
                    </div>
                    <div
                        class="product-message fail"
                        v-else-if="item.status === productCodeStatus.exist"
                    >
                      {{ `${$t(`hospitalw_message_product_${item.status}`)} (${item.name})` }}
                    </div>
                    <div
                        class="product-message fail"
                        v-else-if="item.status === productCodeStatus.notFound "
                    >
                      {{ $t(`hospitalw_message_product_${item.status}`) }}
                    </div>
                  </div>
                </div>
                <a-button
                    type="button"
                    class="add-product-btn"
                    @click="addProductRow"
                >
                  <template #icon>
                    <i class="fa-solid fa-plus"/> {{ $t('hospitalw_add_product_btn') }}
                  </template>
                </a-button>
              </div>
            </div>
            <div class="d-flex item-btn-area">
              <a-button
                  @click="$router.push('/hospital')"
                  class="certi-cancel-btn"
              >
                {{ $t('common_cancel') }}
              </a-button>
              <a-button
                  type="primary"
                  @click="addHospital"
                  class="certi-submit-btn"
              >
                {{ $t('hospital_header_register') }}
              </a-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getAccessToken } from '@/utils/tokenStore';
import jsonFile from '../../assets/locations.json';
import {
  oneBtnDialog,
  changeBytesToMegabytes,
  confirmDialog,
  phoneNumberFormatter,
  businessNumberFormatter,
  jwtDecoder,
  deepCopy
} from '../../utils/utils';

import { productCodeStatus, MedicalDept } from '../../utils/enums';

export default {
  name: 'AddHospital',
  components: {},
  computed: {
    visibleZeissApprovalItem() {
      const companyId = jwtDecoder(getAccessToken());
      return companyId === process.env.VUE_APP_ZEISS_ID
    },
    visiblePlasmappApprovalItem() {
      const companyId = jwtDecoder(getAccessToken());
      if(companyId && (companyId === process.env.VUE_APP_PLASMAPP_ID ||
          companyId === '64bf3a11924c1a9724dd2404')) {
        return true;
      } else {
        return false;
      }
    },
  },
  data() {
    return {
      type: 'HOSPITAL',

      deptList: [], // 병원 구분
      areaFirst: [], // 시군구 대분류
      areaSecond: [], // 시군구 중분류
      areaThird: [], // 읍면동 소분류
      selectedAreaFirst: '', // 선택된 시군구 대분류
      selectedAreaSecond: '', // 선택된 시군구 중분류
      selectedAreaThird: '', // 선택된 읍면동 소분류
      addrDetail: '', // 상세주소
      medicalDept: [], // 선택된 병원구분
      inputText: '',

      hospitalName: '', // 병원명
      hospitalCeoName: '', // 병원장명
      hospitalPhoneNumber: '', // 병원명
      hospitalCode: '', // 요양기관 코드
      doctors: [], // 재직 의사
      businessNumber: '', // 사업자번호

      managerName: '', // 관리자 이름
      managerPhoneNumber: '', // 관리자 연락처
      managerId: '', // 관리자 아이디
      managerDuty: '', // 관리자 직급
      password: '', // 관리자 비밀번호
      passwordConfirm: '', // 비밀번호 확인

      businessFileName: '', // 사업자이미지 파일명
      businessFileData: null, // 실제 사업자이미지파일 정보가 담긴 폼데이터
      businessImgUrl: '', // objectStorage 상 사업자이미지 url

      logoFileName: '', // 로고이미지 파일명
      logoFileData: null, // 실제 로고파일 정보가 담긴 폼데이터
      logoImgUrl: '', // objectStorage 상 로고이미지 url

      // 검증관련 불리언, 필수값에 따라 추가
      isBusinessNumberValid: false,
      isPasswordValid: false,
      isManagerIdValid: false,

      isPasswordVisible: false,
      isPasswordConfirmVisible: false,
      hasRequested: false,

      approvedItems: [],
      selectedApproveItem: null,

      productArray: [],
      productCodeStatus: productCodeStatus,
    };
  },
  async mounted() {
    await this.getAreaList();
    await this.getDeptList();
    await this.getApprovedItems();
    this.addProductRow();
  },

  methods: {
    changeBytesToMegabytes,
    phoneNumberFormatter,
    businessNumberFormatter,
    changeHospitalPhoneNumber() {
      this.hospitalPhoneNumber = phoneNumberFormatter(this.hospitalPhoneNumber.toString());
    },
    changeManagerPhoneNumber() {
      this.managerPhoneNumber = phoneNumberFormatter(this.managerPhoneNumber.toString());
    },
    changeManagerId() {
      this.isManagerIdValid = false;
      if (document.querySelector('.managerIdMsg'))
        document.querySelector('.managerIdMsg').innerHTML = '';
    },
    changeBusinessNumber(e) {
      this.businessNumber = businessNumberFormatter(this.businessNumber);
      this.isBusinessNumberValid = false;
      if (document.querySelector('.businessNumberMsg'))
        document.querySelector('.businessNumberMsg').innerHTML = '';
    },
    // 과 목록 가져오기
    async getDeptList() {
      try {
        const response = await this.$apiInstance.get(`/items/medical/depts`);
        if (response.status === 200 || response.status === 201) {
          this.deptList = response.data.filter(item => item.code !== MedicalDept.COMMON);
        }

      } catch (error) {
        console.log(error);
        await oneBtnDialog(this.$i18n.t('hospitalw_message_get_dept_title'),this.$i18n.t('hospitalw_message_get_dept_content'), false);
      }
    },
    getAreaList() {
      this.areaFirst = Object.keys(jsonFile)
      .sort((a, b) => a.localeCompare(b, 'ko-KR'));
      this.selectedAreaFirst = '';
      this.selectedAreaSecond = '';
      this.selectedAreaThird = '';
    },
    
    // 시도 변화에 따른 시군구 값 넣기
    areaSecondChange() {
      if(this.selectedAreaFirst) {
        const secondLevelData = jsonFile[this.selectedAreaFirst];
        if(secondLevelData) {
          this.areaSecond = Object.keys(secondLevelData)
          .sort((a, b) => a.localeCompare(b, 'ko-KR'));
          this.selectedAreaSecond = '';
          this.selectedAreaThird = '';
          this.areaThird = [];
        } else {
          this.selectedAreaSecond = '';
          this.selectedAreaThird = '';
          this.areaSecond = [];
          this.areaThird = [];
        }
      } else {
        this.selectedAreaSecond = "";
        this.selectedAreaThird = "";
        this.areaSecond = [];
        this.areaThird = [];
      }
    },
    
    areaThirdChange() {
      if (this.selectedAreaSecond) {
        if(!jsonFile[this.selectedAreaFirst]) {
          this.selectedAreaThird = '';
          this.areaThird = [];
          return;
        }
        const thirdLevelData =
          jsonFile[this.selectedAreaFirst][this.selectedAreaSecond];
          if(thirdLevelData) {
            this.areaThird = Object.keys(thirdLevelData)
            .sort((a, b) => a.localeCompare(b, 'ko-KR'));
            this.selectedAreaThird = '';
          } else {
            this.selectedAreaThird = '';
            this.areaThird = [];
          }
      } else {
        this.selectedAreaThird = '';
        this.areaThird = [];
      }
    },
    async getApprovedItems() {
      try {
        const response = await this.$apiInstance.get(`/items/approval/items`);
        if (response.status === 200 || response.status === 201) {
          this.approvedItems = response.data;
          // 자이스의 경우
          if(this.visibleZeissApprovalItem) {
            this.approvedItems = this.processZeissApprovedItems(response.data);
            return;
          }

          // 플라즈맵의 경우
          if(this.visiblePlasmappApprovalItem) {
            this.approvedItems = this.processPlasmappApprovedItems(response.data);
            if(Array.isArray(this.approvedItems) && this.approvedItems.length > 0) {
              this.selectedApproveItem = this.approvedItems[0]._id;
            }

            return;
          }
        }
      } catch (error) {
        console.log(error);
        await oneBtnDialog(this.$i18n.t('hospitalw_message_get_item_title'),this.$i18n.t('hospitalw_message_get_item_content'), false);
      }
    },
    processZeissApprovedItems(array) {
      const newArray = deepCopy(array);
      for(const item of newArray) {
        item.editedName = item.itemName.replace(/\(.*?\)\s?/g, '');
        item.isSelected = false;
        item.text = this.$i18n.t('hospitalw_message_not_authorized');
      }
      return newArray;
    },
    processPlasmappApprovedItems(array) {
      const newArray = deepCopy(array);
      return newArray;
    },
    addProductRow() {
      const obj = {};
      obj.status = productCodeStatus.notChecked;
      obj.value = '';
      obj.id = '';
      obj.name = '';
      this.productArray.push(obj);
    },
    async validateProductCode(index) {

      const productCode = this.productArray[index];
      try {
        if(productCode.value.length > 0) {
          // code : ok면 프로덕트아이디도 줌
          const response = await this.$apiInstance.get(`/companies/by/${productCode.value}`);
          if(response.status === 200 || response.status === 201) {
            if(response.data.code === productCodeStatus.ok) {
              productCode.status = productCodeStatus.ok;
              productCode.id = response.data.productId;
              productCode.name = response.data.param;
            }
          }
        } else {
          productCode.status = productCodeStatus.notChecked;
          productCode.id = '';
          productCode.name = '';
        }

      } catch (error) {
        console.log(error);
        if(error && error.response) {
          if(error.response.status === 400) {
            productCode.status = productCodeStatus.exist;
            productCode.id = '';
            productCode.name = error.response.data.param;
          } else if(error.response.status === 404) {
            productCode.status = productCodeStatus.notFound;
            productCode.id = '';
            productCode.name = '';
          } else {
            await oneBtnDialog(this.$i18n.t('hospitalw_message_productcode_title'),this.$i18n.t('hospitalw_message_productcode_content'), false);
          }
        }
      }
    },
    removeProduct(index) {
      this.productArray.splice(index, 1);
    },
    async addHospital() {
      if(!await this.validateData()) return;
      if(this.hasRequrested) return;
      this.hasRequested = true;

      try {
        const obj = {};

        const deptArr = new Array();
        this.medicalDept.forEach((ele) => {
          deptArr.push(ele);
        });

        const doctorArr = new Array();
        const filteredArray = this.doctors.filter((element) => element !== '');

        if(filteredArray.length > 0) {
          filteredArray.forEach((ele) => {
            doctorArr.push(ele);
          });
        }

        obj.medicalDept = deptArr;
        obj.name = this.hospitalName;
        if(this.hospitalCeoName) obj.ceo = this.hospitalCeoName;
        obj.cNo = this.businessNumber.replace(/-/g, '');
        obj.addrOne = this.selectedAreaFirst;
        obj.addrTwo = this.selectedAreaSecond;
        obj.addrThree = this.selectedAreaThird;
        if(this.addrDetail) obj.addrDetail = this.addrDetail;

        if(this.businessFileData) {
          obj.cNoUrl = this.businessFileName;
          const businessImgUrl = await this.uploadImageOnObjectStorage(this.businessFileData);
          obj.cNoUrl = businessImgUrl;
        } else {
          obj.cNoUrl = '';
        }
        if(this.logoFileData) {
          obj.imgUrl = this.logoFileName;
          const logoImgUrl = await this.uploadImageOnObjectStorage(this.logoFileData);
          obj.imgUrl = logoImgUrl;
        }

        if(this.hospitalPhoneNumber) {
          obj.call = this.hospitalPhoneNumber.replace(/-/g, '');
        } else {
          obj.call = '';
        };

        const approvalItemIds = [];
        if(this.visibleZeissApprovalItem) {
          for(const item of this.approvedItems) {
            if(item.isSelected) approvalItemIds.push(item._id);
          }
        } else if(this.visiblePlasmappApprovalItem) {
          approvalItemIds.push(this.selectedApproveItem);
        }

        if(approvalItemIds.length > 0) obj.approvalItemIds = approvalItemIds;

        obj.hospitalCode = this.hospitalCode;
        obj.type = this.type;
        if(doctorArr.length > 0) obj.doctors = doctorArr;

        const accountInfo = {};
        accountInfo.username = this.managerId.trim();
        accountInfo.password = this.password;
        accountInfo.role = this.type;
        accountInfo.name = this.managerName;
        if(this.managerDuty) accountInfo.duty = this.managerDuty;
        if(this.managerPhoneNumber) accountInfo.mobile = this.managerPhoneNumber.replace(/-/g, '');

        obj.accountInfo = accountInfo;

        if(this.productArray.length > 0) {
          const approvalProductIds = [];
          for(const item of JSON.parse(JSON.stringify(this.productArray))) {
            if(item.id) approvalProductIds.push(item.id);
          }
          obj.approvalProductIds = approvalProductIds;
        }

        const response = await this.$apiInstance.post(`/companies`, obj);
        if(response.status === 200 || response.status === 201) {
          await oneBtnDialog(this.$i18n.t('hospitalw_message_add_done_title'), this.$i18n.t('hospitalw_message_add_done_content'), false);
          this.$router.push('/hospital');
        } else {
          this.hasRequested = false;
          await oneBtnDialog(this.$i18n.t('hospitalw_message_add_fail_title'), this.$i18n.t('hospitalw_message_add_fail_content'), false);
        }
        this.hasRequested = false;
      } catch (error) {
        console.log(error);
        if(error.response && error.response.status === 400) {
          await oneBtnDialog(this.$i18n.t('hospitalw_message_acc_exist_title'), this.$i18n.t('hospitalw_message_acc_exist_content'), false);
        } else {
          await oneBtnDialog(this.$i18n.t('hospitalw_message_add_fail_title'), this.$i18n.t('hospitalw_message_add_fail_content'), false);
        }
        this.hasRequested = false;
      }
    },
    async validateProductArray() {
      const valueSet = new Set();
      let hasDuplicate = false;

      for (let product of this.productArray) {
        // Check for duplicate values
        if (valueSet.has(product.value)) {
          hasDuplicate = true;
          break;
        }
        valueSet.add(product.value);
        // Check for invalid status
        if (product.value !== '' &&
            product.status !== productCodeStatus.ok &&
            product.status !== productCodeStatus.notChecked) {
          return 'invalid';
        }
      }
      if (hasDuplicate) {
        return 'duplicate';
      }

      return '';
    },

    async validateManagerId() {
      this.isManagerIdValid = true;
      const managerIdMsg = document.querySelector('.managerIdMsg');
      if(!this.managerId) {
        managerIdMsg.setAttribute('class', 'managerIdMsg fail');
        managerIdMsg.innerHTML = this.$i18n.t('hospitalw_message_manager_id_err_content');
        this.isManagerIdValid = false;
      } else if(!/^[a-zA-Z0-9]*$/.test(this.managerId)) {
        managerIdMsg.setAttribute('class', 'managerIdMsg fail');
        managerIdMsg.innerHTML = this.$i18n.t('hospitalw_message_manager_id_korean_err');
        this.isManagerIdValid = false;
      } else {
        try {
          const response = await this.$apiInstance.get(`/accounts/duplicateCheck/${this.managerId}`);
          if (
              response &&
              (response.status === 200 || response.status === 201) &&
              !response.data
          ) {
            managerIdMsg.setAttribute('class', 'managerIdMsg success');
            managerIdMsg.innerHTML = this.$i18n.t('hospitalw_message_manager_id_okay');
            this.isManagerIdValid = true;
            // 엘스부터 시작.
          } else {
            managerIdMsg.setAttribute('class', 'managerIdMsg fail');
            managerIdMsg.innerHTML = this.$i18n.t('hospitalw_message_manager_id_exist');
            this.isManagerIdValid = false;
          }
        } catch (error) {
          console.log(error);
          await oneBtnDialog(this.$i18n.t('hospitalw_message_manager_invalid_title'),this.$i18n.t('hospitalw_message_manager_invalid_content'), false);
        }
      }
    },
    // 사업자번호 validate
    async validateBusinessNumber() {
      let isTryingForceAdd = false;
      this.isBusinessNumberValid = true;
      const businessNumberMsg = document.querySelector('.businessNumberMsg');
      if (!this.businessNumber) {
        businessNumberMsg.setAttribute('class', 'businessNumberMsg fail');
        businessNumberMsg.innerHTML = this.$i18n.t('hospitalw_message_cno_err');
        this.isBusinessNumberValid = false;
      } else if(this.businessNumber.replaceAll('-','').length < 10) {
        businessNumberMsg.setAttribute('class', 'businessNumberMsg fail');
        businessNumberMsg.innerHTML = this.$i18n.t('hospitalw_message_format_err');
        this.isBusinessNumberValid = false;
      } else {
        try {
          const response = await this.$apiInstance.get(`/companies/duplicateCheck/cNo/${this.businessNumber.replaceAll('-','')}`);
          if (
              response &&
              (response.status === 200 || response.status === 201) &&
              !response.data
          ) {
            businessNumberMsg.setAttribute('class', 'businessNumberMsg success');
            businessNumberMsg.innerHTML = this.$i18n.t('hospitalw_message_cno_okay');
            this.isBusinessNumberValid = true;
          } else {
            const confirmResult = await confirmDialog(this.$i18n.t('hospitalw_add_by_cno_title'), this.$i18n.t('hospitalw_add_by_cno_msg'));
            if(confirmResult) {
              const obj = {};
              obj.cNo = this.businessNumber.replaceAll('-','');
              isTryingForceAdd = true;
              const response = await this.$apiInstance.post(`/companies/exist/hospital/force/add`, obj);
              if (
                  response &&
                  (response.status === 200 || response.status === 201) &&
                  response.data
              ) {
                await oneBtnDialog(this.$i18n.t('hospitalw_message_add_done_title'), this.$i18n.t('hospitalw_message_add_done_content'), false);
                this.$router.push('/hospital');
              }

            }
            businessNumberMsg.setAttribute('class', 'businessNumberMsg fail');
            businessNumberMsg.innerHTML = this.$i18n.t('hospitalw_message_cno_exist');
            this.isBusinessNumberValid = false;
          }
        } catch(error) {
          console.log(error);
          if(isTryingForceAdd === true) {
            await oneBtnDialog(this.$i18n.t('hospitalw_message_add_fail_title'), this.$i18n.t('hospitalw_message_add_fail_content'), false);
          }
        }
      }
    },
    // 파일 형식 valitdate
    validateFile(file) {
      let result = true;
      if (
          file.type !== 'image/png' &&
          file.type !== 'image/jpeg' &&
          file.type !== 'image/jpg'
      ) {
        alert(this.$i18n.t('hospitalw_message_file_type'));
        result = false;
      } else if (changeBytesToMegabytes(file.size) > 100) {
        alert(this.$i18n.t('hospitalw_message_file_size'));
        result = false;
      }

      return result;
    },

    validateFileSize(file) {
      let result = true;
      if (changeBytesToMegabytes(file.size) > 100) {
        alert(this.$i18n.t('hospitalw_message_file_size'));
        result = false;
      }
      return result;
    },

    // 사업자등록증 이미지 onChange메소드
    changeBusinessNumImage() {
      const fileInput = document.getElementById('businessFileInputM');
      if (fileInput.files && fileInput.files[0]) {
        const validateFileSize = this.validateFileSize(fileInput.files[0]);
        if(validateFileSize) {
          this.businessFileName = fileInput.files[0].name;
          const formData = new FormData();
          formData.append('file', fileInput.files[0]);
          this.businessFileData = formData;
          this.isBusinessNumberUploaded = true;
        }
      }
    },

    async clickBusinessFileInput() {
      let fileInput = document.getElementById('businessFileInputM');
      fileInput.click();
    },

    // 사업자등록증 파일 다운로드
    downloadBusinessNumImage() {
      const fileInput = this.$refs.businessFileInputM;
      const file = fileInput.files[0];
      if (file) {
        const downloadLink = document.createElement('a');
        downloadLink.href = URL.createObjectURL(file);
        downloadLink.download = file.name;
        downloadLink.click();
      } else {
        const downloadLink = document.createElement('a');
        downloadLink.target = '_blank';
        downloadLink.href = this.businessImgUrl;
        downloadLink.download = this.businessFileName;
        downloadLink.click();
      }
    },

    // 사업자등록증 파일 삭제
    deleteBusinessNumFile(){
      this.businessFileName = '';
      this.businessFileData = null;
      this.businessImgUrl = '';
      this.isBusinessNumberUploaded = false;
    },

    // 로고 이미지 onChange메소드 및 미리보기
    changeLogoImage() {
      const fileInput = document.getElementById('logoFileInputM');
      if (fileInput.files && fileInput.files[0]) {
        const validateFile = this.validateFile(fileInput.files[0]);
        if (validateFile) {
          const reader = new FileReader();
          reader.onload = function (e) {
            document.getElementById('logoPrevM').setAttribute('src', e.target.result);
          };
          reader.readAsDataURL(fileInput.files[0]);
          this.logoFileName = fileInput.files[0].name;

          const formData = new FormData();
          formData.append('file', fileInput.files[0]);
          this.logoFileData = formData;
        }
      }
    },

    downloadLogoImage() {
      const fileInput = this.$refs.logoFileInputM;
      if(fileInput) {
        const file = fileInput.files[0];
        if (file) {
          const downloadLink = document.createElement('a');
          downloadLink.href = URL.createObjectURL(file);
          downloadLink.download = file.name;
          downloadLink.click();
        } else {
          const downloadLink = document.createElement('a');
          downloadLink.target = '_blank';
          downloadLink.href = this.logoImgUrl;
          downloadLink.download = this.logoFileName;
          downloadLink.click();
        }
      } else {
        const downloadLink = document.createElement('a');
        downloadLink.target = '_blank';
        downloadLink.href = this.logoImgUrl;
        downloadLink.download = this.logoFileName;
        downloadLink.click();
      }
    },

    // 이미지 오브젝트스토리지에 업로드
    async uploadImageOnObjectStorage(fileData) {
      try {
        const response = await this.$apiInstance.post(`/object-storages`, fileData);
        if (response.status === 200 || response.status === 201) {
          return response.data.url;
        } else {
          return '';
        }
      } catch(error) {
        console.log(error);
        return '';
      }
    },

    // 업로드 전 검증
    async validateData() {
      let result = true;
      if(!this.hospitalName) {
        await oneBtnDialog(this.$i18n.t('hospitalw_message_name_err_title'), this.$i18n.t('hospitalw_message_name_err_content'), false);
        result = false;
      } else if (this.medicalDept.length === 0) {
        await oneBtnDialog(this.$i18n.t('hospitalw_message_medicaldept_err_title'), this.$i18n.t('hospitalw_message_medicaldept_err_content'), false);
        result = false;
      } else if( !this.selectedAreaFirst ||
          !this.selectedAreaSecond ||
          !this.selectedAreaThird
      ) {
        await oneBtnDialog(this.$i18n.t('hospitalw_message_region_err_title'), this.$i18n.t('hospitalw_message_region_err_content'), false);
        result = false;
      } else if(!this.businessNumber) {
        await oneBtnDialog(this.$i18n.t('hospitalw_message_cno_err_title'), this.$i18n.t('hospitalw_message_cno_err_content'), false);
        result = false;
      } else if(!this.isBusinessNumberValid) {
        await oneBtnDialog(this.$i18n.t('hospitalw_message_cno_valid_err_title'), this.$i18n.t('hospitalw_message_cno_valid_err_content'), false);
        result = false;
      } else if (this.businessNumber.replaceAll('-','').length < 10) {
        await oneBtnDialog(this.$i18n.t('hospitalw_message_cno_format_err_title'), this.$i18n.t('hospitalw_message_cno_format_err_content'), false);
        result = false;
      } else if(await this.validateProductArray() === 'invalid') {
        await oneBtnDialog(this.$i18n.t('hospitalw_message_product_invalid_err_title'), this.$i18n.t('hospitalw_message_product_invalid_err_content'), false);
        result = false;
      } else if(await this.validateProductArray() === 'duplicate') {
        await oneBtnDialog(this.$i18n.t('hospitalw_message_product_duplicate_err_title'), this.$i18n.t('hospitalw_message_product_duplicate_err_content'), false);
        result = false;
      } else if(this.visiblePlasmappApprovalItem && !this.selectedApproveItem) {
        await oneBtnDialog(this.$i18n.t('hospitalw_message_product_plasmapp_noitem_title'), this.$i18n.t('hospitalw_message_product_plasmapp_noitem_content'), false);
        result = false;
      }
      return result;
    },
    passwordOnChange() {
      if(this.password && (this.password !== this.passwordConfirm)) {
        this.isPasswordValid = false;
      } else {
        this.isPasswordValid = this.validatePassword(this.password);
      }
      console.log(this.password, this.passwordConfirm, this.isPasswordValid)
    },
    validatePassword(password) {
      const regexAlphabets = /[a-zA-Z]/;
      const regexNumbers = /[0-9]/;

      if (
          password.length >= 8 &&
          password.length <= 16 &&
          regexAlphabets.test(password) &&
          regexNumbers.test(password)
      ) {
        return true;
      } else {
        return false;
      }
    },
    // 병원코드, 의료종사자번호, 사업자번호(중복확인 필요한 값들)의 값 변경 시 valid false로 재설정
    deleteLogoImage() {
      this.logoFileData = '';
      this.logoFileName = null;
      this.logoImgUrl = '';
    },
    addDoctor() {
      if (this.inputText.trim() !== '') {
        this.doctors.push(this.inputText.trim());
        this.inputText = '';
      }
    },
    removeDoctor(index) {
      this.doctors.splice(index, 1);
    },

    toggleShowPassword(type) {
      if(type === 'password') {
        this.isPasswordVisible = !this.isPasswordVisible;
      } else if(type === 'newPassword') {
        this.isNewPasswordVisible = !this.isNewPasswordVisible;
      } else {
        this.isPasswordConfirmVisible = !this.isPasswordConfirmVisible;
      }
    },
    timelineButtonMove(index) {
      const item = this.approvedItems[index];
      if (item.isSelected) {
        return 'left:17px;background:#fff;  animation :pulse 0.5s; animation-duration:1s;';
      } else {
        return 'left:2px;background:#fff)';
      }
    },
    timeLineButtonText(index) {
      const item = this.approvedItems[index];
      if (item.isSelected) {
        return 'text-align:left;';
      } else {
        return 'text-align:right;';
      }
    },
    async clickLogoFileInput() {
      let fileInput = document.getElementById('logoFileInputM');
      fileInput.click();
    },
  },
};
</script>

<style lang="scss" scoped>
@media screen and (max-width:767px) {
  .row{
    padding: 14px 14px 36px 14px !important
  }
  .hospital-div-wrap .div905 .black-btn{
    width: auto;
    padding: 10px 5px;
  }
  .hospital-div-wrap .button-box{
    margin-left: 0;
  }
  .certi-btn-regular{
    padding: 6.5px 9px;
  }
  .w-35{
    width: 100% !important;
  }
  .hospital-div-wrap .black-btn{
    width: 100px !important;
    padding: 8px 12px;
  }
  .hospital-div-wrap .password-area button{
    top: 43px;
  }
  .item-btn-area{
    max-width: none;
  }
  p{
    margin-bottom: 0;
  }
}
@media screen and (min-width:768px) and (max-width:1023px){
  .w-35 {
    width: 50% !important;
  }
  p{
    margin-bottom: 0;
  }
}
</style>